import Eye from '../../src/legacy/Eye.tsx';
export default Eye;
